import React from "react";
import ReactGridLayoutWrapper from "./ReactGridLayoutWrapper";
import "./MainContent.scss";
import GlobalBanner from "../banner/GlobalBanner";
import {
  eventCategories,
  recordEvent
} from "../../utils/googleAnalyticsEvents";
import type { Layout as GridLayout } from "react-grid-layout";
import type { LayoutItem, Widget } from "../../types/models";

export interface MainContentProps {
  id?: string | null;
  uid?: string;
  widgetList?: Widget[];
  layout?: LayoutItem[];
  numberOfColumns?: number;
  isLoggedIn?: boolean;
  isLayoutLocked?: boolean;
  onLayoutChange?: (update: {
    widgetList: Widget[];
    layout: GridLayout;
  }) => void;
}

export default class MainContent extends React.Component<MainContentProps> {
  static defaultProps = {
    id: null,
    widgetList: [],
    layout: []
  };

  onLayoutChange = (layout: GridLayout) => {
    const { widgetList = [], isLoggedIn } = this.props;
    if (isLoggedIn) {
      recordEvent(
        "Layout Adjusted",
        eventCategories.LAYOUT_CONFIGURATION,
        "Layout Adjusted"
      );
      this.props.onLayoutChange?.({ widgetList, layout });
    }
  };

  render() {
    const { widgetList, layout, numberOfColumns, isLayoutLocked } = this.props;
    return (
      <div id="main-content">
        <GlobalBanner />
        <ReactGridLayoutWrapper
          widgetList={widgetList}
          isLayoutLocked={isLayoutLocked}
          layout={layout}
          numberOfColumns={numberOfColumns}
          onLayoutChange={this.onLayoutChange}
          onDragStart={() =>
            recordEvent(
              "Grid Item Moved",
              eventCategories.LAYOUT_CONFIGURATION,
              "Grid Item Moved"
            )
          }
          onResizeStart={() =>
            recordEvent(
              "Grid Item Resized",
              eventCategories.LAYOUT_CONFIGURATION,
              "Grid Item Resized"
            )
          }
        />
      </div>
    );
  }
}
